const hexToRgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));

const toHsl = ([r, g, b]) => {
  const [R, G, B] = [r / 255, g / 255, b / 255];
  const max = Math.max(R, G, B);
  const min = Math.min(R, G, B);
  const l = (max + min) / 2;
  const d = max - min;
  if (!d) return [0, 0, l * 100];
  const s = d / (1 - Math.abs(2 * l - 1));
  const h = max === R ? ((G - B) / d) % 6 : max === G ? (B - R) / d + 2 : (R - G) / d + 4;
  return [Math.round((h * 60 + 360) % 360), Math.round(s * 100), Math.round(l * 100)];
};

const luminance = (hex) => {
  const c = hexToRgb(hex).map((v) => {
    const x = v / 255;
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
};

export const contrast = (a, b) => {
  const [x, y] = [luminance(a), luminance(b)].sort((m, n) => n - m);
  return (x + 0.05) / (y + 0.05);
};

export const textOn = (hex) => (contrast(hex, "#ffffff") >= contrast(hex, "#0f172a") ? "#ffffff" : "#0f172a");

const hslToHex = (h, s, l) => {
  const a = (s / 100) * Math.min(l / 100, 1 - l / 100);
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const c = l / 100 - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
    return Math.round(255 * c).toString(16).padStart(2, "0");
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};

const vars = (prefix, hex) => {
  const [h, s, l] = toHsl(hexToRgb(hex));
  let sl = l;
  while (sl > 5 && contrast(hslToHex(h, s, sl), "#ffffff") < 4.5) sl -= 2;
  const strong = `hsl(${h} ${s}% ${sl}%)`;
  return {
    [`--${prefix}`]: hex,
    [`--${prefix}-fg`]: textOn(hex),
    [`--${prefix}-soft`]: `hsl(${h} ${Math.min(s, 90)}% 95%)`,
    [`--${prefix}-border`]: `hsl(${h} ${Math.min(s, 80)}% 80%)`,
    [`--${prefix}-strong`]: strong,
    [`--${prefix}-hsl`]: `${h} ${s}% ${l}%`,
  };
};

export function brandStyle(colors) {
  if (!colors?.primary) return {};
  const p = vars("brand", colors.primary);
  const fg = toHsl(hexToRgb(p["--brand-fg"]));
  return {
    ...p,
    ...(colors.accent ? vars("accent-brand", colors.accent) : {}),
    "--primary": p["--brand-hsl"],
    "--ring": p["--brand-hsl"],
    "--primary-foreground": `${fg[0]} ${fg[1]}% ${fg[2]}%`,
  };
}

export const brandClass = (colors) => `${colors?.primary ? "brand-scope" : ""} ${colors?.accent ? "brand-accent" : ""}`.trim();
